export const FETCH_TRANSACTIONS_STARTED = "FETCH_TRANSACTIONS_STARTED";

export const FETCH_TRANSACTIONS_SUCCEDEED = "FETCH_TRANSACTIONS_SUCCEDEED";
export const FETCH_TRANSACTIONS_FAILED = "FETCH_TRANSACTIONS_FAILED";
export const FETCH_TRANSACTIONS_RETRY = "FETCH_TRANSACTIONS_RETRY";
export const LOAD_MORE_TRANSACTIONS_STARTED = "LOAD_MORE_TRANSACTIONS_STARTED";
export const LOAD_MORE_TRANSACTIONS_SUCCEDEED =
  "LOAD_MORE_TRANSACTIONS_SUCCEDEED";
export const LOAD_MORE_TRANSACTIONS_FAILED = "LOAD_MORE_TRANSACTIONS_FAILED";
export const NO_MORE_TRANSACTIONS = "NO_MORE_TRANSACTIONS";
export const LOAD_MORE_SCHEDULED_TRANSACTIONS_STARTED = "LOAD_MORE_SCHEDULED_TRANSACTIONS_STARTED";
export const LOAD_MORE_SCHEDULED_TRANSACTIONS_SUCCEEDED =
  "LOAD_MORE_SCHEDULED_TRANSACTIONS_SUCCEEDED";
export const LOAD_MORE_SCHEDULED_TRANSACTIONS_FAILED = "LOAD_MORE_SCHEDULED_TRANSACTIONS_FAILED";
export const NO_MORE_SCHEDULED_TRANSACTIONS = "NO_MORE_SCHEDULED_TRANSACTIONS";
export const GET_TRANSACTIONS_DATE_STARTED = "GET_TRANSACTIONS_DATE_STARTED";
export const GET_TRANSACTIONS_DATE_SUCCEDEED =
  "GET_TRANSACTIONS_DATE_SUCCEDEED";
export const GET_TRANSACTIONS_DATE_FAILED = "GET_TRANSACTIONS_DATE_FAILED";
export const CHANGE_BANK_START_DATE = "CHANGE_BANK_START_DATE";
export const CHANGE_BANK_END_DATE = "CHANGE_BANK_END_DATE";
export const CHANGE_BUDGET_DATA = "CHANGE_BUDGET_DATA";
export const FETCH_BENEFICIARY_TRANSACTIONS_STARTED =
  "FETCH_BENEFICIARY_TRANSACTIONS_STARTED";
export const FETCH_BENEFICIARY_TRANSACTIONS_SUCCEDEED =
  "FETCH_BENEFICIARY_TRANSACTIONS_SUCCEDEED";
export const FETCH_BENEFICIARY_TRANSACTIONS_FAILED =
  "FETCH_BENEFICIARY_TRANSACTIONS_FAILED";
export const LOAD_MORE_BENEFICIARY_TRANSACTIONS_STARTED =
  "LOAD_MORE_BENEFICIARY_TRANSACTIONS_STARTED";

export const LOAD_MORE_BENEFICIARY_TRANSACTIONS_SUCCEDEED =
  "LOAD_MORE_BENEFICIARY_TRANSACTIONS_SUCCEDEED";
export const LOAD_MORE_BENEFICIARY_TRANSACTIONS_FAILED =
  "LOAD_MORE_BENEFICIARY_TRANSACTIONS_FAILED";
export const SET_DATE_FILTER_TRANSACTIONS = "SET_DATE_FILTER_TRANSACTIONS";
export const SET_EXPORT_OPTIONS = "SET_EXPORT_OPTIONS";
export const SET_FILE_TYPE = "SET_FILE_TYPE";
export const RESET_TRANSACTIONS = "RESET_TRANSACTIONS";
export const SET_FILTER_START_DATE = "SET_FILTER_START_DATE";
export const SET_FILTER_END_DATE = "SET_FILTER_END_DATE";
export const EXPORT_TRANSACTIONS_STARTED = "EXPORT_TRANSACTIONS_STARTED";
export const EXPORT_TRANSACTIONS_SUCCEDEED = "EXPORT_TRANSACTIONS_SUCCEDEED";
export const EXPORT_TRANSACTIONS_FAILED = "EXPORT_TRANSACTIONS_FAILED";
export const SET_SINGLE_MODAL_DATA = "SET_SINGLE_MODAL_DATA";
export const GET_CATEGORIES_STARTED = "GET_CATEGORIES_STARTED";
export const GET_CATEGORIES_SUCCEDEED = "GET_CATEGORIES_SUCCEDEED";
export const GET_CATEGORIES_FAILED = "GET_CATEGORIES_FAILED";
export const GET_TAGS_STARTED = "GET_TAGS_STARTED";
export const GET_TAGS_SUCCEDEED = "GET_TAGS_SUCCEDEED";
export const GET_TAGS_FAILED = "GET_TAGS_FAILED";
export const GET_SCHEDULED_PAYMENTS_STARTED = "GET_SCHEDULED_PAYMENTS_STARTED";
export const GET_SCHEDULED_PAYMENTS_SUCCEDEED =
  "GET_SCHEDULED_PAYMENTS_SUCCEDEED";
export const GET_SCHEDULED_PAYMENTS_FAILED = "GET_SCHEDULED_PAYMENTS_FAILED";
export const REFRESH_PAYMENT_TRANSACTIONS_STARTED =
  "REFRESH_PAYMENT_TRANSACTIONS_STARTED";
export const REFRESH_PAYMENT_TRANSACTIONS_SUCCESS =
  "REFRESH_PAYMENT_TRANSACTIONS_SUCCESS";
export const REFRESH_PAYMENT_TRANSACTIONS_FAILED =
  "REFRESH_PAYMENT_TRANSACTIONS_FAILED";
export const RESET_GET_TRANSACTIONS_DATE = "RESET_GET_TRANSACTIONS_DATE";
export const FETCH_BULK_TRANSACTION_STARTED = "FETCH_BULK_TRANSACTION_STARTED";
export const FETCH_BULK_TRANSACTION_SUCCEEDED = "FETCH_BULK_TRANSACTION_SUCCEEDED";
export const FETCH_BULK_TRANSACTION_FAILED = "FETCH_BULK_TRANSACTION_FAILED";
export const SET_SINGLE_BULK_MODAL_DATA = "SET_SINGLE_BULK_MODAL_DATA";
export const FETCH_FILTERED_TRANSACTIONS_SUCCEDEED = "FETCH_FILTERED_TRANSACTIONS_SUCCEDEED";
export const FETCH_FILTERED_TRANSACTIONS_STARTED = "FETCH_FILTERED_TRANSACTIONS_STARTED";
export const FETCH_FILTERED_TRANSACTIONS_FAILED = "FETCH_FILTERED_TRANSACTIONS_FAILED";
export const RESET_CHECK_BALANCE = "RESET_CHECK_BALANCE"

export const FETCH_NET_CASH_ANALYTICS_STARTED = "FETCH_NET_CASH_ANALYTICS_STARTED"
export const FETCH_NET_CASH_ANALYTICS_SUCCEEDED = "FETCH_NET_CASH_ANALYTICS_SUCCEEDED"
export const FETCH_NET_CASH_ANALYTICS_FAILED = "FETCH_NET_CASH_ANALYTICS_FAILED"
export const UPDATE_OLD_TRANSACTION_LIST = "UPDATE_OLD_TRANSACTION_LIST"
export const REFRESH_DASHBOARD="REFRESH_DASHBOARD";
export const SHOW_FLOAT_REFRESH_BUTTON="SHOW_FLOAT_REFRESH_BUTTON";

// Transaction History
export const SET_TRANSACTIONS_HISTORY_FILTER = "SET_TRANSACTIONS_HISTORY_FILTER";
export const FETCH_TRANSACTIONS_HISTORY_STARTED = "FETCH_TRANSACTIONS_HISTORY_STARTED";
export const FETCH_TRANSACTIONS_HISTORY_SUCCEEDED = "FETCH_TRANSACTIONS_HISTORY_SUCCEEDED";
export const FETCH_TRANSACTIONS_HISTORY_FAILED = "FETCH_TRANSACTIONS_HISTORY_FAILED";
